import { GenericEvent } from "types/Events";

import store from "../../core/store";

export default (): GenericEvent[] => {
  return store.getState();
};
